import React from "react";
import styles from "./ProfileDetailRow.module.css";
import noUser from "../../assets/no-user.png";
import { truncateContent } from "utils/ContentTruncationComputer";

export enum ProfileRowPlacementType {
    STANDALONE,
    LIST,
}

type ProfileDetailRowProps = {
    profilePictureUrl?: string; // Optional profile picture URL
    name: string; // Display name
    altText?: string; // Alt text for the image
    className?: string;
    isReadOnly?: boolean;
    placement?: ProfileRowPlacementType;
    onProfilePictureClick?: () => void;
    truncationLength?: number;
    textSize?: 'small' | 'regular';
};

const ProfileDetailRow: React.FC<ProfileDetailRowProps> = ({
    profilePictureUrl,
    name,
    altText,
    className,
    isReadOnly,
    placement = ProfileRowPlacementType.STANDALONE,
    onProfilePictureClick,
    truncationLength = 20,
    textSize = 'regular',
}) => {

    let mainStyle = styles.profileDetailContainer;

    switch (placement) {
        case ProfileRowPlacementType.STANDALONE:
            mainStyle = styles.profileDetailContainer;
            break;
        case ProfileRowPlacementType.LIST:
            mainStyle = styles.profileDetailInListContainer;
            break;
    }

    const truncatedName = truncateContent(name, truncationLength);
    const textSizeStyle = textSize == 'regular' ? styles.regularFont : styles.smallFont;

    return (
        <div className={`${styles.profileDetailContainerCommon} ${mainStyle} ${className} ${isReadOnly ? styles.readOnlyBackground : ''} ${textSizeStyle}`}>
            <img
                src={profilePictureUrl || noUser}
                alt={altText || name}
                className={styles.profilePicture}
                onClick={onProfilePictureClick}
            />
            <div className={styles.name}>{truncatedName}</div>
        </div>
    );
};

export default ProfileDetailRow;
